import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyClp'
})
export class CurrencyClpPipe implements PipeTransform {

  transform(value: number, showSymbol: boolean = true): string {
    if (showSymbol) {
      return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(value);
    } else {
      return new Intl.NumberFormat('es-CL', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);
    }
  }

}
